<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 26" enable-background="new 0 0 26 26" xml:space="preserve">
    <path d="M3,14.111h8.889V3H3V14.111z M3,23h8.889v-6.667H3V23z M14.111,23H23V11.889h-8.889V23z M14.111,3v6.667H23V3H14.111z"/>
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'dashboard'
}
</script>
